import { Button } from '@mui/material'
import { DIALOGS } from '~/components/Charts/chrome/chartChrome'
import { exportPinsToJson, downloadJson } from '~/pin/exportToJson'
import type { PinV1 } from '~/pin/PinV1'

export function ExportButton({ collectionName, pins }: { collectionName: string; pins: PinV1[] }) {
  return (
    <Button
      size="small"
      disabled={pins.length === 0}
      onClick={() => downloadJson(`${collectionName}.pins.json`, exportPinsToJson(pins))}
    >
      {DIALOGS.exportLayoutJson}
    </Button>
  )
}
